<script setup lang="ts">
import { type PropType, computed } from 'vue'
import { type User } from '../types'

const props = defineProps({
  user: {
    type: Object as PropType<User>,
    required: true,
  },
  size: {
    type: String,
    default: 'medium',
  },
})

// 安全地获取用户名
const userName = computed(() => {
  return props.user?.username || '?'
})

// 根据用户名计算头像颜色
const avatarColor = computed(() => {
  if (!userName.value) return 'primary'

  const colors = ['primary', '#FFD43A', '#ADFF00', '#262824', 'danger']
  const index = userName.value.charCodeAt(0) % colors.length
  return colors[index]
})

// 检查是否为URL
const isUrl = (avatar: string | undefined) => {
  if (!avatar) return false
  return avatar.startsWith('http') || avatar.startsWith('blob:')
}

// 计算头像显示文本
const fallbackText = computed(() => {
  const username = userName.value
  if (!username || username === '?') return '?'

  try {
    // 如果用户名包含空格，尝试使用姓名首字母组合
    if (username.includes(' ')) {
      const [firstName, lastName] = username.split(' ')
      return `${firstName[0]}${lastName ? lastName[0] : ''}`
    }

    // 否则返回用户名的第一个字符
    return username[0].toUpperCase()
  } catch {
    return '?'
  }
})
</script>

<template>
  <VaAvatar
    :size="size"
    :src="isUrl(props.user.avatar) ? props.user.avatar : ''"
    :fallback-text="fallbackText"
    :color="avatarColor"
  />
</template>
